import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getSupportNav: () => NavRoute = () => {
    return {
        name: 'Support',
        // Accessible to everyone (the Support permission is granted to all profiles).
        security: (s) => s.support,
        path: 'support/list',
    };
};
